/**
 * Authentication debugging utilities
 */

export const debugAuthCallback = () => {
  const url = window.location.href;
  const hash = window.location.hash;
  const search = window.location.search;
  
  console.log('🔍 Auth Debug Info:');
  console.log('🔍 Full URL:', url);
  console.log('🔍 Hash:', hash);
  console.log('🔍 Search params:', search);
  
  // Parse hash parameters
  if (hash) {
    const hashParams = new URLSearchParams(hash.substring(1));
    console.log('🔍 Hash params:');
    for (const [key, value] of hashParams.entries()) {
      if (key === 'access_token') {
        console.log(`🔍   ${key}: ${value.substring(0, 20)}...`);
      } else {
        console.log(`🔍   ${key}: ${value}`);
      }
    }
  }
  
  // Parse query parameters
  if (search) {
    const queryParams = new URLSearchParams(search);
    console.log('🔍 Query params:');
    for (const [key, value] of queryParams.entries()) {
      console.log(`🔍   ${key}: ${value}`);
    }
  }
  
  return {
    hasHash: !!hash,
    hasQuery: !!search,
    hashParams: hash ? Object.fromEntries(new URLSearchParams(hash.substring(1))) : {},
    queryParams: search ? Object.fromEntries(new URLSearchParams(search)) : {},
  };
};

export const getEnvironmentInfo = () => {
  const origin = window.location.origin;
  const hostname = window.location.hostname;
  const port = window.location.port;
  const protocol = window.location.protocol;
  
  const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';
  const isProduction = !isLocal && (
    hostname.includes('netlify.app') || 
    hostname.includes('vercel.app') || 
    hostname.includes('snapalyze.com')
  );
  
  console.log('🌍 Environment Info:');
  console.log('🌍 Origin:', origin);
  console.log('🌍 Hostname:', hostname);
  console.log('🌍 Port:', port);
  console.log('🌍 Protocol:', protocol);
  console.log('🌍 Is Local:', isLocal);
  console.log('🌍 Is Production:', isProduction);
  
  return {
    origin,
    hostname,
    port,
    protocol,
    isLocal,
    isProduction,
  };
};
